class UserActionClass {
    constructor(actionType, inputQuery, snsObject, categoryObject, shownQuery, additionalData, dtLinkScenario) {

        this.actionType = actionType;

        this.inputQuery = inputQuery;
        this.shownQuery = shownQuery || inputQuery;
        this.snsObject = snsObject ? {
            longKey: snsObject.longKey,
            shortKey: snsObject.shortKey,
            scenarioResponse: snsObject.scenarioResponse,
            botType: snsObject.botType,
            scenarioObject: snsObject.scenario,
            scenarioStrategy: snsObject.scenarioStrategy
        } : snsObject;

        this.categoryObject = categoryObject ? {
            scenarioTitle: categoryObject.scenarioTitle,
            scenarioResponse: categoryObject.scenarioResponse,
            scenarioStrategy: categoryObject.scenarioStrategy,
            scenario: categoryObject.scenario
        } : categoryObject;
        //done temporarily to handle create sr action on dff form
        this.additionalData = additionalData
        this.dtLinkScenario = dtLinkScenario

    }
}

export default UserActionClass


// WEBPACK FOOTER //
// ./src/objectClasses/user-action-class.js